import classNames from "classnames";
import Link from "next/link";

import { Action, Category } from "@/constants/events";
import { useEventTracker } from "@/hooks/useEventTracker";
import { useDispatch } from "@/redux/hooks";
import { requestLocation } from "@/redux/slices/location";

import NotFoundIcon from "@/components/Icons/not_found.svg";

const DealsPromosNoResults: React.FC<{ className?: string; type: string }> = ({
  className,
  type,
}) => {
  const dispatch = useDispatch();
  const { publishEvent } = useEventTracker();

  const onChangeLocation = () => {
    publishEvent({
      action: Action.click,
      category: Category.button,
      label: "change your location",
    });
    dispatch(requestLocation());
  };

  return (
    <div
      className={classNames(
        className,
        "border border-light-grey rounded flex justify-center items-center p-lg",
      )}
    >
      <div className="text-center">
        <NotFoundIcon className="mx-auto mb-sm" width={48} />
        <p className="font-bold text-center">
          There are no {type} near this location right now
        </p>
        <p className="text-xs">
          You can learn about{" "}
          <Link href="/strains/lists" className="underline">
            cannabis strains
          </Link>
          ,{" "}
          <Link href="/dispensaries" className="underline">
            find dispensaries near you
          </Link>{" "}
          or{" "}
          <button className="underline" onClick={onChangeLocation}>
            change your location
          </button>
          .
        </p>
      </div>
    </div>
  );
};

export default DealsPromosNoResults;
